import React, {useState} from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Home from './Pages/Home';
import TrackingNumber from './Pages/TrackingNumber'
import ScrollToTop from "./components/ScrollToTop";
import Wallet from './Pages/Wallet';
import TryAndBuyReceipt from './Pages/TryAndBuyReceipt';
import TryAndBuyAuth from './Pages/TryAndBuyAuth';
import TryAndBuyOrder from './Pages/TryAndBuyOrder';
import NotFound from './Pages/NotFound';

function App() {
  const [lang] = useState(localStorage.getItem('lang'))

  return (
    <BrowserRouter>
    <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Navigate to={lang ? `/${lang}` : '/en'} replace />} />
        <Route path="/:lang" element={<Home />} />
        <Route path="/:lang/:trackingNumber" element={<TrackingNumber />} />
        <Route path="/:lang/payments/wallet" element={<Wallet />} />
        <Route path="/:lang/try-and-buy/receipt/:trackingNumber" element={<TryAndBuyReceipt />} />
        <Route path="/:lang/try-and-buy/auth" element={<TryAndBuyAuth />} />
        <Route path="/:lang/try-and-buy/order" element={<TryAndBuyOrder />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
